import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SNACKBAR_DISPLAY':
      return Object.assign({}, state, {
        snackBarVisible: action.payload.visible
      })
    case 'SNACKBAR_COPY':
      return Object.assign({}, state, {
        snackBarCopy: action.payload.copy
      })
    case 'UPDATE_CURRENT_PAGE':
      return Object.assign({}, state, {
        currentPage: action.payload.pageName
      })
    case 'SCREEN_TYPE':
      return Object.assign({}, state, {
        screenType: action.payload.screenType
      })
    default:
      return state
  }
}

export default reducer
